import { createReducer } from '../../helpers/reducers';
import * as routeTypes from '../../routes/types';

import { types } from '../../actions/search';

const toSearchText = str => str.replace(/-/g, ' ');

const initialState = '';

const handleSearchQueryRequest = (state, action) => toSearchText(action.payload.queryText);

const handlers = {
  [types.SEARCH_QUERY.REQUEST]: handleSearchQueryRequest,
};

const lastQueryText = createReducer(initialState, handlers);

export default lastQueryText;

export const getSearchLastQueryText = state => state.search.lastQueryText;



// WEBPACK FOOTER //
// ./src/reducers/search/lastQueryText.js